import PropTypes from 'prop-types';
import React from 'react';
import PrimaryHeader from '../../common/PrimaryHeader';
import { containerApp } from '../../../main';

const SimpleHeader = ({ heading, children }) => (
  <PrimaryHeader>
    <div
      className="c-header-primary__item u-position-relative large-and-up-ph small-ph-- u-pv-"
      display-if={!containerApp.isActive()}
    >
      <div className="c-heading c-heading--dark c-heading--main-header" data-automation-id="text:header">
        {heading}
      </div>
    </div>
    {/* Prevent layout breaking for container app */}
    <div display-if={containerApp.isActive()} />
    {children}
  </PrimaryHeader>
);
SimpleHeader.propTypes = {
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  children: PropTypes.node,
};
SimpleHeader.defaultProps = {
  children: null,
};

export default SimpleHeader;
